import { render, staticRenderFns } from "./JoinRoom.vue?vue&type=template&id=21912e33&scoped=true&"
import script from "./JoinRoom.vue?vue&type=script&lang=js&"
export * from "./JoinRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21912e33",
  null
  
)

export default component.exports